import { HeadlessTableRow, HeadlessTableConfig } from './types'

export function tableConfig<R extends HeadlessTableRow>() {
  function create<
    T extends HeadlessTableConfig<R, FP, SP, QP>,
    FP extends keyof T['filters'] | (string & {}),
    SP extends keyof T['sorts'] | (string & {}),
    QP extends keyof T['quickFilters'] | (string & {})
  >(config: T): T {
    return {
      ...config
    }
  }
  return { create }
}
